export default __webpack_public_path__ + "static/media/hamburger_light.89ee381b.svg";